// Copyright (c) 2024 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.

export const TOKEN_ID ='d07d686f60842c01f1d314f37e2f5e57e41a132b2f51afc7c4f62c809136b936'